import { render, staticRenderFns } from "./CatalogServiceEditor.vue.js?vue&type=template&id=4a7f492d&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogServiceEditor.vue?vue&type=template&id=4a7f492d&scoped=true"
import script from "./CatalogServiceEditor.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogServiceEditor.vue?vue&type=script&lang=js"
export * from "./CatalogServiceEditor.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogServiceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f492d",
  null
  
)

export default component.exports